define(function (require, exports, module) {
    return {};
});
